import { Pipe, PipeTransform } from '@angular/core'
import { ICssFilters } from '@components/exportable/css-filters-control/interfaces/i-css-filters'
import { TCssFilter } from '@components/exportable/css-filters-control/types/t-css-filter'

@Pipe({
  name: 'filterValue',
  standalone: true,
})

export class FilterValuePipe implements PipeTransform {
  transform(cssFilters: ICssFilters, key: TCssFilter): number {
    return cssFilters[key].value
  }
}
